<template>
	<div class="form__datepicker-item is-daterange">
		<div class="form__label-wrapper">
			<label :for="item.id" class="form__datepicker-label">
				{{item.label}}
			</label>
		</div>
		<div class="form__datepicker-wrapper">
			<input :id="item.id" :name="item.id" data-js-item="js-form-datepicker" autocomplete="off" type="text" :data-js-datetyp="item.datetype" class="form__datepicker-text" :data-classes="item.classes" :value="item.value" :placeholder="item.placeholder"/>
		</div>
	</div>
</template>
<script>
export default {
  	name: "FilterNewsroomEventInputItem",
	props: ["item"],
  	components: {
  	},
  	computed: {
  	}
};
</script>
